export const isValidEmail = ({ email }: { email: string }) => {
  // regex taken from https://bobbyhadz.com/blog/react-check-if-email-is-valid
  return /\S+@\S+$/.test(email);
};
